import { animeSingleProps } from "@helpers/animations";
import React from "react";
import Anime from "react-anime";
import { useInView } from "react-intersection-observer";

export interface ModuleProps extends React.ComponentPropsWithoutRef<"div"> {
  animate?: boolean;
}

const Module: React.FC<ModuleProps> = ({ animate, children }) => {
  const { ref, inView } = useInView({
    threshold: 0.2
  });
  const mergedAnime = {
    ...animeSingleProps,
    ...(inView ? { autoplay: true } : { autoplay: false }),
    ...{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      complete: (anim: any) => {
        if (anim.animatables.length) {
          anim.animatables[0].target.style.transform = "";
        }
      }
    }
  };
  return (
    <div ref={ref}>
      {animate ? <Anime {...mergedAnime}>{children}</Anime> : <>{children}</>}
    </div>
  );
};

Module.defaultProps = {};

export { Module };
